namespace GeniuzPOS.Inventory {
    export interface IcStockApproveSetAssembleDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        PluCode?: string;
        PluDesc?: string;
        SellUnitRatio?: number;
        SetItemQty?: number;
        SetQty?: number;
        Qty?: number;
        SkuCode?: string;
        SkuQty?: number;
        UnitCost?: number;
        CostValue?: number;
        ExpDate?: string;
        Remark?: string;
    }

    export namespace IcStockApproveSetAssembleDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockApproveSetAssembleDt';
        export const deletePermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';
        export const insertPermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';
        export const readPermission = '2Inventory:การประกอบสินค้า:อนุมัติ:View';
        export const updatePermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            SellUnitRatio = "SellUnitRatio",
            SetItemQty = "SetItemQty",
            SetQty = "SetQty",
            Qty = "Qty",
            SkuCode = "SkuCode",
            SkuQty = "SkuQty",
            UnitCost = "UnitCost",
            CostValue = "CostValue",
            ExpDate = "ExpDate",
            Remark = "Remark"
        }
    }
}
